import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
// eslint-disable-next-line
import styles from "./styles/source_sans_pro.css";
// npm i --save vuetify-dialog@2.X.X
import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.css";

Vue.config.productionTip = false;

Vue.use(VuetifyDialog, { context: { vuetify } });

new Vue({
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
